import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Tab, TabList } from '@tremor/react';
import { MdCheckCircle } from 'react-icons/md';
import { Title, NewScreen } from '_atoms';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedArchive, setSelectedArchive } from '_redux/slices/archive/archive';
import ArchiveList from './ArchiveList';
import ArchiveForm from './ArchiveForm';
import ArchiveDetail from './ArchiveDetail';

const Archive = () => {
    const dispatch = useDispatch();
    const [tab, setTab] = useState(1);
    const [showSuccess, setShowSuccess] = useState(false);
    const selectedArchive = useSelector(selectSelectedArchive);

    const handleArchiveSelect = (archive) => {
        dispatch(setSelectedArchive(archive));
        setTab(1);
    };

    const handleFormSuccess = () => {
        setShowSuccess(true);
    };

    const handleSuccessConfirm = () => {
        setShowSuccess(false);
        setTab(1);
    };

    return (
        <NewScreen>
            <Row>
                <Col>
                    <Title
                        subtitle="Archive"
                        description="Browse and manage per-flight document archives (boarding documents, manifests, incident paperwork, etc.)"
                    />
                </Col>
            </Row>

            <Row>
                <TabList
                    value={tab}
                    onValueChange={(value) => {
                        setTab(value);
                        setShowSuccess(false);
                        if (value === 1) dispatch(setSelectedArchive(null));
                    }}
                    marginTop="mt-6"
                >
                    <Tab value={1} text="Archives" />
                    <Tab value={2} text="Create Archive" />
                </TabList>
            </Row>

            {tab === 1 && !selectedArchive && (
                <ArchiveList
                    onSelect={handleArchiveSelect}
                    onAddArchive={() => setTab(2)}
                />
            )}

            {tab === 1 && selectedArchive && (
                <ArchiveDetail
                    archiveId={selectedArchive.id}
                    onBack={() => dispatch(setSelectedArchive(null))}
                />
            )}

            {tab === 2 && !showSuccess && (
                <ArchiveForm
                    onSuccess={handleFormSuccess}
                    onCancel={() => setTab(1)}
                />
            )}

            {tab === 2 && showSuccess && (
                <Row className="mt-4">
                    <Col xs={12}>
                        <div style={{
                            width: '100%',
                            background: '#D1E7DD',
                            border: '1px solid #A3CFBB',
                            borderLeft: '6px solid #198754',
                            borderRadius: 8,
                            padding: '24px 28px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: 18,
                            flexWrap: 'wrap',
                        }}>
                            <div style={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                background: '#fff',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                flexShrink: 0,
                                boxShadow: '0 2px 6px rgba(21, 87, 36, 0.15)',
                            }}>
                                <MdCheckCircle size={40} color="#198754" />
                            </div>
                            <div style={{ flex: 1, minWidth: 240 }}>
                                <p style={{ margin: 0, fontWeight: 700, fontSize: 17, color: '#155724' }}>
                                    Archive Created
                                </p>
                                <p style={{ margin: '4px 0 0', color: '#155724', fontSize: 14 }}>
                                    The flight archive has been saved and any attachments have been uploaded.
                                </p>
                            </div>
                            <button
                                type="button"
                                onClick={handleSuccessConfirm}
                                style={{
                                    padding: '10px 28px',
                                    border: 'none',
                                    borderRadius: 8,
                                    background: '#198754',
                                    color: '#fff',
                                    fontSize: 14,
                                    fontWeight: 600,
                                    cursor: 'pointer',
                                    flexShrink: 0,
                                }}
                            >
                                Done
                            </button>
                        </div>
                    </Col>
                </Row>
            )}
        </NewScreen>
    );
};

export default Archive;
